import { getNavigationType } from '../../utils/get-navigation-type.js';
export const buildViewArticleEvent = (inputProperties) => ({
    ...inputProperties,
    object: Promise.resolve(inputProperties.object).then((objectProperties) => {
        const { articleId, ...rest } = objectProperties;
        return {
            ...rest,
            id: articleId,
            navigationType: getNavigationType(),
            type: 'Article',
            contentId: articleId,
            url: window.location.href,
        };
    }),
});
//# sourceMappingURL=event-builder.js.map